"use client";

import { cn, formatViews } from "@/lib/utils";

interface StatisticCardProps {
	label: string;
	numericValue: number;
	bgColor: string;
	onClick?: () => void;
}

const StatisticCard = ({ label, numericValue, bgColor, onClick }: StatisticCardProps) => {
	return (
		<div
			className={cn(
				"flex w-fit cursor-pointer items-center justify-center gap-1 rounded-lg px-3 py-1.5 md:px-4 md:py-3",
				bgColor
			)}
			onClick={onClick}
		>
			<span className="text-center text-xxs font-semibold uppercase tracking-wider text-gray-500 md:text-xs">
				{label}
			</span>

			<p className="text-base font-bold text-gray-900 md:text-xl">{formatViews(numericValue)}</p>
		</div>
	);
};

export default StatisticCard;
